import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { motion } from 'framer-motion';
const audiences = [{
  title: 'Psiquiatras Infantojuveniles',
  desc: 'Sistematizá tu práctica, blindate legalmente y trabajá con la autoridad clínica que la especialidad exige.'
}, {
  title: 'Residentes de Psiquiatría Infantojuvenil',
  desc: 'Protocolos claros y plantillas listas para usar desde tu primer turno con pacientes menores.'
}, {
  title: 'Psiquiatras Generales que Atienden Menores',
  desc: 'Todo lo que necesitás saber sobre el marco legal y clínico específico de trabajar con niños y adolescentes.'
}, {
  title: 'Preparación para Concurso Infantojuvenil',
  desc: 'Razonamiento clínico y manejo legal que te diferencia en la evaluación desde el día uno.'
}];
export function Audience() {
  return <div className="bg-slate-50" data-id="element-18">
      <SectionWrapper data-id="element-19">
        <div className="text-center mb-8 md:mb-12" data-id="element-20">
          <h2 className="text-[22px] md:text-3xl font-extrabold text-[#0a1f44] mb-2 md:mb-4 tracking-tight" data-id="element-21">
            ¿PARA QUIÉN ES?
          </h2>
          <h3 className="text-[18px] md:text-2xl font-semibold text-slate-700 mb-3 md:mb-4" data-id="element-22">
            Diseñado para vos
          </h3>
          <p className="text-slate-600 max-w-2xl mx-auto text-[14px] md:text-base text-balance" data-id="element-23">
            Si querés ejercer la psiquiatría infantojuvenil con otra cabeza
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 max-w-4xl mx-auto" data-id="element-24">
          {audiences.map((aud, i) => <motion.div key={i} whileHover={{
          scale: 1.02
        }} className="bg-white p-5 md:p-8 rounded-2xl shadow-sm ring-1 ring-slate-900/5 hover:shadow-md transition-all flex flex-col md:flex-row gap-4 md:gap-5 items-start" data-id="element-25">
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-blue-50 flex items-center justify-center shrink-0 ring-4 ring-blue-50/50" data-id="element-26">
                <span className="text-blue-600 font-bold text-lg" data-id="element-27">{i + 1}</span>
              </div>
              <div data-id="element-28">
                <h4 className="text-[16px] md:text-lg font-bold text-[#0a1f44] mb-1.5 md:mb-2" data-id="element-29">
                  {aud.title}
                </h4>
                <p className="text-slate-600 text-[13px] md:text-sm leading-relaxed" data-id="element-30">
                  {aud.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-8 md:mt-12 text-center" data-id="element-31">
          <div className="inline-flex items-center justify-center space-x-2 bg-emerald-50 text-emerald-700 px-4 py-2 md:py-2.5 rounded-full text-[13px] md:text-sm font-semibold ring-1 ring-emerald-200/60 shadow-sm" data-id="element-32">
            <span data-id="element-33">🛡️</span>
            <span data-id="element-34">¿No estás seguro? Tenés 7 días de garantía.</span>
          </div>
        </div>
      </SectionWrapper>
    </div>;
}